import styled from "styled-components";

// 루트 컨테이너
export const WorksRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  color: #1D1D1D;
  min-height: 100vh;
  padding: 0 240px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

// 헤더 섹션
export const WorksHeader = styled.div`
  width: 100%;
  padding-top: 160px;
  padding-bottom: 50px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    padding-top: calc(160px * 100vw / 1920);
    padding-bottom: calc(50px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    padding-top: 120px;
    padding-bottom: 40px;
  }
  
  @media (max-width: 1000px) {
    padding-top: 110px;
    padding-bottom: 40px;
  }
  
  @media (max-width: 768px) {
    padding-top: 100px;
    padding-bottom: 56px;
    max-width: 100%;
  }
`;

export const WorksTitle = styled.h1`
  color: #1D1D1D;
  font-size: 48px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 70px;
  word-wrap: break-word;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(48px * 100vw / 1920);
    line-height: calc(70px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 40px;
    line-height: 56px;
  }
  
  @media (max-width: 1000px) {
    font-size: 36px;
    line-height: 50px;
  }
  
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -1%;
  }
`;

// 필터 컨테이너
export const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 60px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    margin-bottom: calc(60px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    margin-bottom: 50px;
  }
  
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 25px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 48px;
    gap: 32px;
    max-width: 100%;
  }
`;

// 필터 네비게이션
export const FilterNavigation = styled.div`
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 50px;
  position: relative;
  
  @media (max-width: 1920px) {
    height: calc(50px * 100vw / 1920);
    gap: calc(50px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    height: 45px;
    gap: 30px;
  }
  
  @media (max-width: 1000px) {
    width: 100%;
  }
  
  @media (max-width: 768px) {
    height: auto;
    gap: 16px;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    
    &::-webkit-scrollbar {
      display: none;
    }
    
    touch-action: pan-x;
    overflow-y: hidden;
  }
`;

export const FilterUnderline = styled.div`
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #FF4F00;
  
  &.animated {
    transition: all 0.3s ease;
  }
  
  @media (max-width: 1920px) {
    height: calc(3px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    height: 2.5px;
  }
  
  @media (max-width: 768px) {
    height: calc(3px * 100vw / 768);
  }
`;

interface FilterItemProps {
  active: boolean;
}

export const FilterItem = styled.div<FilterItemProps>`
  padding: 0;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
  
  @media (max-width: 1920px) {
    padding: 7px 0;
  }

  @media (max-width: 1400px) {
    padding-bottom: 8px;
  }

  @media (max-width: 768px) {
    padding-top: calc(16px * 100vw / 768);
    padding-bottom: 0;
    touch-action: pan-x;
    pointer-events: auto;
    user-select: none;
  }
`;

export const FilterText = styled.div<{ active: boolean }>`
  color: ${props => props.active ? '#1D1D1D' : '#999999'};
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 36px;
  word-wrap: break-word;
  white-space: nowrap;
  
  @media (max-width: 1920px) {
    font-size: calc(24px * 100vw / 1920);
    line-height: calc(36px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 20px;
    line-height: 30px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    letter-spacing: -1%;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    transform: translateZ(0);
  }
`;

// 검색 컨테이너
export const SearchContainer = styled.div<{ active: boolean }>`
  width: 300px;
  height: 46px;
  padding: 10px;
  border-bottom: 1px ${props => props.active ? '#1D1D1D' : '#1D1D1D'} solid;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    width: calc(300px * 100vw / 1920);
    height: calc(46px * 100vw / 1920);
    padding: calc(10px * 100vw / 1920);
    gap: calc(10px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    width: 260px;
    height: 42px;
    padding: 8px;
    gap: 8px;
  }
  
  @media (max-width: 1000px) {
    width: 100%;
    order: -1;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    height: 46px;
    padding: 10px;
    border-width: 1px;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  line-height: 26px;
  width: 100%;
  box-sizing: border-box;
  
  &::placeholder {
    color: #999999;
  }
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(26px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 15px;
    line-height: 24px;
  }
  
  @media (max-width: 1000px) {
    font-size: 15px;
    line-height: 22px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 26px;
  }
`;

export const SearchIcon = styled.div<{ active: boolean }>`
  position: relative;
  
  svg path {
    stroke: ${props => props.active ? '#1D1D1D' : '#999999'};
    transition: stroke 0.3s ease;
  }
  
  @media (max-width: 1920px) {
    svg {
      width: calc(24px * 100vw / 1920);
      height: calc(24px * 100vw / 1920);
    }
  }
  
  @media (max-width: 1400px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  @media (max-width: 1000px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 768px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

// 작품 그리드
export const WorksGrid = styled.div`
  width: 100%;
  padding: 0 0 120px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 90px 20px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    gap: calc(90px * 100vw / 1920) calc(20px * 100vw / 1920);
    padding: 0 0 calc(120px * 100vw / 1920) 0;
  }
  
  @media (max-width: 1400px) {
    gap: 50px 20px;
    padding: 0 0 100px 0;
  }
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
  
  @media (max-width: 768px) {
    gap: 50px;
    padding: 0 0 40px;
  }
`;

export const WorkCard = styled.div<{ isPrivate?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 30px;
  cursor: ${props => props.isPrivate ? 'default' : 'pointer'};
  box-sizing: border-box;
  overflow: hidden;
  
  @media (max-width: 1920px) {
    gap: calc(30px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    gap: 20px;
  }
  
  @media (max-width: 768px) {
    gap: 12px;
    max-width: 100%;
  }
`;

export const WorkImage = styled.div`
  width: 100%;
  aspect-ratio: 335/187;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
    transform-origin: center;
  }
  
  ${WorkCard}:hover & img {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    border-radius: 12px;
    max-width: 100%;
  }
`;

export const WorkContent = styled.div`
  width: 100%;
  height: 82px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    height: calc(82px * 100vw / 1920);
    gap: calc(8px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    height: 75px;
    gap: 6px;
  }
  
  @media (max-width: 768px) {
    height: auto;
    gap: 4px;
    max-width: 100%;
  }
`;

export const WorkTitle = styled.h3`
  width: 100%;
  color: #1D1D1D;
  font-size: 32px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 700;
  line-height: 46px;
  word-wrap: break-word;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(32px * 100vw / 1920);
    line-height: calc(46px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 24px;
    line-height: 34px;
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const WorkTags = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  
  @media (max-width: 1920px) {
    gap: calc(16px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const WorkTag = styled.div`
  color: #999999;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -1%;
  word-wrap: break-word;
  transition: color 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:last-child {
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  ${WorkCard}:hover & {
    color: #FF4F00;
  }
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(28px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 14px;
    line-height: 24px;
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -1%;
    font-weight: 400;
  }
`;

export const LoadMoreButton = styled.button<{ hasMore?: boolean }>`
  width: 60px;
  height: 60px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: ${props => props.hasMore ? 'pointer' : 'default'};
  margin: 0px auto 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('/images/works/more.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 0.3s ease;
  
  &:hover {
    background-image: url('/images/works/more-hovered.png');
  }
  
  @media (max-width: 1920px) {
    width: calc(60px * 100vw / 1920);
    height: calc(60px * 100vw / 1920);
    margin: 0 auto calc(120px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    margin: 40px auto 90px;
  }
`;

// 더보기 버튼 내부 요소들은 이제 필요 없음
export const LoadMoreButtonInner = styled.div`
  display: none;
`;

export const LoadMoreCircle = styled.div`
  display: none;
`;

// 검색 결과 없음 메시지 스타일
export const NoResultsMessage = styled.div`
  width: 100%;
  padding: 120px 0;
  text-align: center;
  color: #999999;
  font-size: 18px;
  font-family: 'Pretendard', sans-serif;
  
  @media (max-width: 1920px) {
    padding: calc(120px * 100vw / 1920) 0;
    font-size: calc(18px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    padding: 80px 0;
    font-size: 17px;
  }
  
  @media (max-width: 768px) {
    padding: 60px 0;
    font-size: 16px;
  }
`;

// 검색어 하이라이트 스타일
export const HighlightSpan = styled.span`
  background-color: rgba(255, 79, 0, 0.2);
  color: #FF4F00;
  font-weight: 500;
`;

// Lock 오버레이 스타일 수정
export const LockOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  
  ${WorkCard}:hover & {
    opacity: 1;
  }
`;

export const LockIcon = styled.div`
  margin-bottom: 12px;
  width: 48px;
  height: 48px;
  background-image: url('/images/works/lock.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  
  @media (max-width: 1920px) {
    margin-bottom: calc(12px * 100vw / 1920);
    width: calc(48px * 100vw / 1920);
    height: calc(48px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

export const LockText = styled.div`
  color: white;
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 500;
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
  }
`;
